/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SvgHome from '../../assets/static/img/home.svg';
import { Link } from 'react-router-dom';
import styles from './BreadCrumb.module.scss';

export interface iBreadCrumb {
  isCurrent?: boolean;
  icon?: React.ReactNode;
  href?: string;
  label?: string;
}

interface BreadCrumbProps {
  breadCrumb?: iBreadCrumb[];
}

export default function BreadCrumb({
  breadCrumb,
}: BreadCrumbProps): JSX.Element | null {
  const xmlnsV = { 'xmlns:v': 'http://rdf.data-vocabulary.org/#' };

  if (!breadCrumb) return null;

  return (
    <ul className={styles.Breadcrumb} {...xmlnsV}>
      <li className={styles.Breadcrumb__li} typeof="v:Breadcrumb">
        <img className={styles.Breadcrumb__label} src={SvgHome} alt="Home" />
        {/* <Link
          to="/"
          rel="v:url"
          property="v:title"
          className={styles.Breadcrumb__label}
        >
          <img className={styles.Breadcrumb__label} src={SvgHome} alt="Home" />
          Home
        </Link> */}
      </li>
      {breadCrumb?.map((page) => {
        return (
          <li
            className={styles.Breadcrumb__li}
            typeof="v:Breadcrumb"
            key={page.label}
          >
            {page.href ? (
              <Link
                to={page.href}
                rel="v:url"
                property="v:title"
                className={styles.Breadcrumb__label}
                data-current={page.isCurrent}
              >
                {page.icon}
                {page.label}
              </Link>
            ) : (
              <span
                data-current={page.isCurrent}
                className={`${styles.Breadcrumb__label} ${styles.Breadcrumb__last}`}
              >
                {page.icon}
                {page.label}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
